export let submitInternalHandle = (
  event: any,
  e: any = null,
  handleSubmit: any
) => {
  if (event === "ENTER") {
    if (e && e.which == 13) {
      handleSubmit();
    }
  } else if (event === "SUBMIT") {
    handleSubmit();
  }
};
